module.exports = __webpack_public_path__ + "static/grebenBcg-544aaa383e06681a4b67c0eb1ee1e827.jpg";